import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_COLOR,
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

const theme = {
  config: {
    // 1. Force the initial mode to light
    initialColorMode: 'light',
    // 2. Disable listening to system/hardware preferences
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '22px',
    subHeading: '58px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        colorScheme: 'light dark',
      },
      // 3. Force body styles to stay light even if the system tries to inject dark mode
      'body, html': {
        background: `${BG_PRIMARY} !important`,
        color: `${TEXT_PRIMARY} !important`,
        backgroundColor: `${BG_PRIMARY} !important`,
        colorScheme: 'light dark !important',
      },
      // 4. Heavy-handed fix for Android WebView force-dark features
      '@media (prefers-color-scheme: dark)': {
        'html, body': {
          background: `${BG_PRIMARY} !important`,
          color: `${TEXT_PRIMARY} !important`,
          backgroundColor: `${BG_PRIMARY} !important`,
          colorScheme: 'light dark !important',
        },
        '*, *::before, *::after': {
          colorScheme: 'light dark !important',
        },
        'img, picture, video, canvas, svg': {
          filter: 'none !important',
        },
      },
    },
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainAssetColor: ASSET_COLOR,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
  breakpoints: {
    base: '0em',
    xs: '360px',
    xp: '390px',
    xr: '410px',
    lg: '480px',
    sm: '480px',
    md: '500px',
  },
};

export default extendTheme(theme);
